export const BREADCRUMBS = [{ label: 'Registration and deactivation notifications' }];
